import React from 'react';
export function TickIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.071 7.05a1 1 0 00-1.414 0l-7.778 7.778-3.536-3.535a1 1 0 00-1.414 1.414l4.243 4.243a1 1 0 001.414 0l8.485-8.486a1 1 0 000-1.414z"
  }));
}